module.exports = __webpack_public_path__ + "img/fruit-dates-190x100.46915262.jpg";